var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3067_13695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7763 11.165L15.3272 7.57281H11.8806V5.24272C11.8806 4.25971 12.3612 3.30097 13.9049 3.30097H15.4729V0.242718C15.4729 0.242718 14.0505 0 12.6913 0C9.85393 0 7.99714 1.71845 7.99714 4.83495V7.57281H4.8418V11.165H7.99714V19.8495C8.63063 19.949 9.27869 20 9.93888 20C10.5991 20 11.2471 19.9466 11.8806 19.8495V11.165H14.7763Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3067_13695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupFacebook);
export default __webpack_public_path__ + "static/media/popup-facebook.26a7d7b28254a2d780eeece9c375f0a6.svg";
export { ForwardRef as ReactComponent };